import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`sales/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        showSaleNumber: (cntx, { id }) => {
            axios.get(`markets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('sales', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`sales/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        exportPurchases: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('export_purchases', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`sales/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        agronomists: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('agronomists', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levels: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levels', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        buyers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('buyers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        markets: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('markets', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        curings: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('curings', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transporters: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transporters', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
